import { DateInput } from './DateInput'
import { withDateInput } from './withDateInput'

const ConnectedDateInput = withDateInput(DateInput)

export { ConnectedDateInput as DateInput }
